import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { CompanyService } from '../../../_services/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-company-contacts',
  templateUrl: './company-contacts.component.html',
  styleUrls: ['./company-contacts.component.css']
})
export class CompanyContactsComponent implements OnInit {
  @Input() companyId;

  // for table
  private contacts: object[];
  private contacts_count: number;
  private page_number: number;
  private page_count: number;
  private page_indicators: number[];

  constructor(private service: CompanyService, private route: ActivatedRoute, private router: Router) { }

  filters = new FormGroup({
    email: new FormControl(''),
    company: new FormControl(''),
    name: new FormControl(''),
    phone: new FormControl('')
  });

  ngOnInit() {

    if (this.companyId) {
      this.refresh();
    }
    this.filters.valueChanges.debounceTime(500).subscribe(
      (value) => {
        this.page_number = 1;
        this.refresh();
      }
    )


  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.companyId) {
      this.filters.reset();
      this.refresh();
    }
  }

  refresh() {
    let params = {}
    Object.assign(params, this.filters.value, { page: this.page_number })
    this.service.getCompanyContacts(this.companyId, params) // Get Contacts List
      .subscribe(response => {
        this.contacts = response.contacts;                      // Contact Page List
        this.contacts_count = parseInt(response.total_count);   // Contact Count
        this.page_number = parseInt(response.page);                       // Current Page
        this.page_count = Math.ceil(this.contacts_count / 25);   // Page Count
        // Page Indicators (for ngFor iterations)
        if (this.page_count < 10) {
          this.page_indicators = Array(this.page_count).fill(1);
        } else {
          this.page_indicators = Array(10).fill(1)
        }
      });
  }


  // Previous Page Button
  previousPage() {
    this.page_number--;
    this.refresh();
  }

  // Next Page Button
  nextPage() {
    this.page_number++;
    this.refresh();
  }

  // Go to page n°nb
  toPage(nb: number) {
    this.page_number = nb;
    this.refresh();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/company-modal/company-contacts/company-contacts.component.ts